import React from "react";
import { RecoilRoot } from "recoil";

import { CorporationInsurance } from '../uiParts/corporations/CorporationInsurance';

const Corporation = (props) => {
  const { init_corporation, insurances } = props;

  return (
    <RecoilRoot>
      <CorporationInsurance init_corporation={init_corporation} insurances={insurances} />
    </RecoilRoot>
  );
};

export default Corporation;
